"use client";

interface BrandLogoSkeletonProps {
  className?: string;
}

/**
 * Animated pulse placeholder for brand logo cells shown while images load.
 */
export function BrandLogoSkeleton({ className = "" }: BrandLogoSkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded-md bg-gray-200 ${className}`}
    />
  );
}
